import gql from 'graphql-tag';

export const getSignedInPeople = gql`
  query getSignedInPeople($facilityId: String) {
    getSignedInPeople(facilityId: $facilityId) {
      id
      name
      facilityId
      gaveConsent
      takenOrientation
      signInTime
      signOutTime
      company
      contactNumber
    }
  }
`;
